<mat-expansion-panel [id]="id" [(expanded)]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <b> {{ oberbegriff.oberbegriff }} </b>
    </mat-panel-title>
    <mat-panel-description> </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="row-zweispaltig">
    <div class="column-zweispaltig">
      <table
        mat-table
        [dataSource]="dataRubrikLinks"
        class="table-breite-komplett"
      >
        <ng-container matColumnDef="SOC_NAME">
          <th *matHeaderCellDef class="mat-column-header-first-entry">
            Merkmal
          </th>

          <td
            mat-cell
            *matCellDef="let entry"
            class="mat-column-cell-first-entry"
          >
            {{ entry.socName }}

            <fa-icon
              *ngIf="entry.onlineInfotext != null"
              [icon]="faInfoCircle"
              class="ml-1 icon-info-select"
              matTooltipClass="tooltip-format"
              matTooltip="{{ entry.onlineInfotext }}"
            ></fa-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="SOC_CODE">
          <th
            *matHeaderCellDef
            class="mat-column-header-left mat-column-header-soc-code"
          >
            SOC Code
          </th>
          <td
            mat-cell
            *matCellDef="let entry"
            class="mat-column-cell mat-column-cell-soc-code"
          >
            {{ entry.socCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="DATENEINGABE">
          <th
            *matHeaderCellDef
            class="mat-column-header mat-column-header-soc-input"
            [ngStyle]="{ display: 'none' }"
          ></th>
          <td
            mat-cell
            *matCellDef="let entry; let i = index"
            class="mat-column-cell mat-column-cell-soc-input"
          >
            <mat-form-field appearance="fill" class="input-field-width">
              <input
                matInput
                [formControl]="formControlLinksList[i]"
                (change)="setValueLinks($event, i)"
                [errorStateMatcher]="matcher"
              />

              <mat-error *ngIf="formControlLinksList[i].hasError('pattern')">
                {{formControlNumberFormatWarning}}
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="MENGEEINHEIT">
          <th
            *matHeaderCellDef
            class="mat-column-header-left mat-column-header-soc-mengeeinheit"
            [attr.colspan]="2"
          >
            Produktionsumfang
          </th>
          <td
            mat-cell
            *matCellDef="let entry"
            class="mat-column-cell mat-column-cell-soc-mengeeinheit"
          >
            {{ entry.mengeeinheit }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColsRubrik"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColsRubrik"></tr>
      </table>
    </div>
    <div class="column-zweispaltig">
      <table
        mat-table
        [dataSource]="dataRubrikRechts"
        class="table-breite-komplett"
      >
      <ng-container matColumnDef="SOC_NAME">
        <th *matHeaderCellDef class="mat-column-header-first-entry">
          Merkmal
        </th>

        <td
          mat-cell
          *matCellDef="let entry"
          class="mat-column-cell-first-entry"
        >
          {{ entry.socName }}

          <fa-icon
              *ngIf="entry.socInfo != null"
              [icon]="faInfoCircle"
              class="ml-1 icon-info-select"
              matTooltipClass="tooltip-format"
              matTooltip="{{ entry.socInfo }}"
            ></fa-icon></td
        ></ng-container>

        <ng-container matColumnDef="SOC_CODE">
          <th
            *matHeaderCellDef
            class="mat-column-header-left mat-column-header-soc-code"
          >
            SOC Code
          </th>
          <td
            mat-cell
            *matCellDef="let entry"
            class="mat-column-cell mat-column-cell-soc-code"
          >
            {{ entry.socCode }}
            <!--   <fa-icon
                  [icon]="faInfoCircle"
                  class="ml-1 icon-info-select"
                  matTooltip={{entry.inlbInfo}}
                ></fa-icon>
                   -->
          </td>
        </ng-container>

        <ng-container matColumnDef="DATENEINGABE">
          <th
            *matHeaderCellDef
            class="mat-column-header mat-column-header-soc-input"
            [ngStyle]="{ display: 'none' }"
          ></th>
          <td
            mat-cell
            *matCellDef="let entry; let i = index"
            class="mat-column-cell mat-column-cell-soc-input"
          >
            <mat-form-field appearance="fill" class="input-field-width">
              <input
                matInput
                [formControl]="formControlRechtsList[i]"
                (change)="setValueRechts($event, i)"
                [errorStateMatcher]="matcher"
              />

              <mat-error *ngIf="formControlRechtsList[i].hasError('pattern')">
                {{formControlNumberFormatWarning}}
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="MENGEEINHEIT">
          <th
            *matHeaderCellDef
            class="mat-column-header-left mat-column-header-soc-mengeeinheit"
            [attr.colspan]="2"
          >
            Produktionsumfang
          </th>
          <td
            mat-cell
            *matCellDef="let entry"
            class="mat-column-cell mat-column-cell-soc-mengeeinheit"
          >
            {{ entry.mengeeinheit }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColsRubrik"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColsRubrik"></tr>
      </table>
    </div>
  </div>
</mat-expansion-panel>
